var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotification24 = function SvgNotification24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.19 2.607a7.707 7.707 0 0 0-4.38 0 6.589 6.589 0 0 0-4.716 6.317v2.772c0 .482-.096.959-.281 1.404l-.18.433c-.24.573-.336 1.236-.182 1.87.16.662.59 1.254 1.302 1.58.556.255 1.287.5 2.247.685V18a4 4 0 0 0 8 0v-.333c1.285-.248 2.16-.602 2.755-.945 1.128-.652 1.138-1.93.796-2.75l-.082-.196a7.32 7.32 0 0 1-.563-2.815V8.924a6.589 6.589 0 0 0-4.717-6.317ZM11.97 18H14a2 2 0 0 1-4 0h1.97Zm.06-2c3.427-.004 5.041-.618 5.718-1.007a.47.47 0 0 0-.044-.252l-.081-.196a9.318 9.318 0 0 1-.717-3.584V8.924a4.589 4.589 0 0 0-3.285-4.4 5.707 5.707 0 0 0-3.242 0 4.589 4.589 0 0 0-3.285 4.4v2.772a5.65 5.65 0 0 1-.435 2.173l-.18.433c-.11.263-.119.49-.085.63a.307.307 0 0 0 .191.233c.821.376 2.43.833 5.385.836h.06Z",
    fill: "currentColor"
  })));
};
export default SvgNotification24;